import { Component, OnInit } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { InputComponent } from '../input/input.component';
import { FiltreService } from '../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class DateInputComponent extends InputComponent implements OnInit {

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }

  /**
   * Les champs de type date ne permette pas d’avoir accès à la donnée en cours de saisie.
   * La variable apparaît vide alors que l’utilisateur a pu commencer à taper quelque chose qui ne sera alors pas sauvegardé.
   * Le champ passe au vert que lorsque la variable n’est plus à vide, même si il n’y a pas de contrôle « require »
   */
  champValide() {
    // Le champ est valide s’il n’y a pas d’erreur croisée
    return this.currentControl.valid && this.currentControl.value !== null
      && this.currentControl.value !== '' && !this.aErreurCroiseeActive();
  }

}
